import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { connectEmployeeToFlexMatchRequest } from 'RestAPIs/flex-match';
import type { ConnectEmployeeToFlexMatchRequestPayload } from 'RestAPIs/flex-match/types';

const useConnectEmployeeToFlexMatchRequest = ({
  isWebSocketUpdate = false
}: {
  isWebSocketUpdate?: boolean;
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ConnectEmployeeToFlexMatchRequestPayload) =>
      connectEmployeeToFlexMatchRequest(payload),
    {
      onSuccess: async () => {
        !isWebSocketUpdate &&
          (await queryClient.refetchQueries('flexMatchTasks'));
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useConnectEmployeeToFlexMatchRequest;
